import { DiaryRequestParams } from "entities/diary/model/types"
import { isArrayEquals } from "shared/lib";

export const areParamsEqual = (
  lastParams: Partial<DiaryRequestParams> | null, 
  currentParams: Partial<DiaryRequestParams> | null
) => {
  if (!lastParams) return false;

  const condition = 
    lastParams.broodFrom === currentParams?.broodFrom&&
    lastParams.broodTo === currentParams?.broodTo&&
    lastParams.framesFrom === currentParams?.framesFrom&&
    lastParams.framesTo === currentParams?.framesTo&&
    lastParams.inspectedAtFrom === currentParams?.inspectedAtFrom&&
    lastParams.inspectedAtTo === currentParams?.inspectedAtTo&&
    lastParams.strengthFrom === currentParams?.strengthFrom&&
    lastParams.strengthTo === currentParams?.strengthTo&&
    lastParams.sortBy === currentParams?.sortBy&&
    lastParams.sort === currentParams?.sort&&
    isArrayEquals(lastParams?.commentKeywords || [], currentParams?.commentKeywords || [])&&
    isArrayEquals(lastParams?.dictionariesIds || [], currentParams?.dictionariesIds || [])&&
    isArrayEquals(lastParams?.authorIds || [], currentParams?.authorIds || [])&&
    isArrayEquals(lastParams?.hiveIds || [], currentParams?.hiveIds || [])
  
  return condition
}